import { Label, MultiButton, MultiButtonProps } from "@mcleod/components";
import { LogManager } from "@mcleod/core";

const log = LogManager.getLogger("lme/datafusion/SendLoadTenderButton");

export class SendLoadTenderButton extends MultiButton {
    private labelSendTender: Label;
    private labelSendRateCon: Label;

    constructor(props?: Partial<MultiButtonProps>) {
        super({ id: props?.id });
        this.createDropdownItems();
        this.primaryButton.caption = "Send Tender",
        this.busyWhenDataSourceBusy = true;
        this.setProps({
            color: "success",
            minWidth: 100,
            ...props
        });
    }

    private createDropdownItems() {
        this.labelSendTender = new Label({ text: "Send Tender", onClick: () => this.sendLoadTender() });
        this.labelSendRateCon = new Label({ text: "Send Rate Confirmation", onClick: () => this.sendRateCon() });
    }

    private sendLoadTender() {
        log.debug("In sendLoadTender()");
    }

    private sendRateCon() {
        log.debug("In sendRateCon()");
    }
}
